import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DataModule } from './data/data.module';
import { ViewsModule } from './views/views.module';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { SecureComponent } from './layouts/secure/secure.component';
import { PublicComponent } from './layouts/public/public.component';
import { HeaderComponent } from './layouts/widgets/header/header.component';
import { FooterComponent } from './layouts/widgets/footer/footer.component';
import { DataSharingService } from './core/data-sharing/data-sharing.service';
import { MobileMenuComponent } from './layouts/widgets/mobile-menu/mobile-menu.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from '../httpconfig.interceptor';
import { DeviceDetectorModule } from 'ngx-device-detector';
import localeTr from '@angular/common/locales/tr';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeTr, 'tr');

@NgModule({
  declarations: [
    AppComponent,
    SecureComponent,
    PublicComponent,
    HeaderComponent,
    FooterComponent,
    MobileMenuComponent,
  ],
  imports: [
    // Angular Modules
    BrowserModule,
    FormsModule,
    AppRoutingModule,

    // Project Modules
    DataModule,
    CoreModule,
    SharedModule,
    ViewsModule,
    DeviceDetectorModule.forRoot()
  ],
  providers: [DataSharingService, {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
    { provide: LOCALE_ID, useValue: "tr" },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/app.module.ts